module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-area"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.getMe.picture
    }
  })]), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.getMe.name))])]), (_vm.showOptions) ? _c('ul', {
    staticClass: "user-area-option"
  }, [_c('li', [_c('span', [_vm._v(_vm._s(_vm.getMe.name))])]), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5bb2408!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/Username/Username.pug
// module id = 265
// module chunks = 2